<template>
  <AlertDialog :open="show" @update:open="(value) => !value && emit('close')">
    <AlertDialogContent class="tw:!max-w-sm tw:gap-12">
      <AlertDialogHeader>
        <div class="tw:flex tw:items-center tw:justify-center tw:mb-4">
          <CheckCircle2 class="tw:w-12 tw:h-12 tw:text-green-500" />
        </div>
        <AlertDialogTitle class="tw:text-center">
          {{ $t('Member successfully added') }}
        </AlertDialogTitle>
        <AlertDialogDescription class="tw:text-center">
          {{ $t('A new member has been added. Do you want to edit the permission for this member?') }}
        </AlertDialogDescription>
      </AlertDialogHeader>

      <AlertDialogFooter class="tw:!justify-center">
        <AlertDialogCancel asChild>
          <Button variant="secondary">{{ $t('Later') }}</Button>
        </AlertDialogCancel>
        <AlertDialogAction asChild>
          <Button @click="emit('editPermissions')">{{ $t('Edit permissions') }}</Button>
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
<script setup lang="ts">
import {
  AlertDialog,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogFooter,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction
} from "@/shadcn/components/ui/alert-dialog";
import {Button} from "@/shadcn/components/ui/button";
import { CheckCircle2 } from "@lucide/vue";

defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'editPermissions'): void;
}>();
</script>
